import { render, staticRenderFns } from "./Atlas.vue?vue&type=template&id=307463e6&scoped=true&"
import script from "./Atlas.vue?vue&type=script&lang=js&"
export * from "./Atlas.vue?vue&type=script&lang=js&"
import style0 from "./Atlas.vue?vue&type=style&index=0&id=307463e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307463e6",
  null
  
)

component.options.__file = "Atlas.vue"
export default component.exports